import {http} from '../http/request';

const loadProjectInfo = projectId => http.get('/scratchProject/get', {id: projectId})
    .then(response => {
        if (response && response.success && response.result) {
            return response.result || null;
        }
        return null;
    });

const loadShareProject = shareId => http.get('/scratchProject/link', {shareId})
    .then(response => {
        if (response && response.success && response.result) {
            return response.result || null;
        }
        return null;
    });

const updateProjectInfo = projectInfo => http.put('/scratchProject', {...projectInfo})
    .then(response => {
        if (response && response.success === false) {
            throw new Error(response.message || 'Project info update failed');
        }
        return response && response.result ? response.result : response;
    });

export default {
    loadProjectInfo,
    loadShareProject,
    updateProjectInfo
};
export {loadProjectInfo, updateProjectInfo,loadShareProject};
